import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }

        if (to.hash) {
            const id = to.hash.replace(/^#/, '')
            let el: Element | null = null

            try {
                el = document.getElementById(id) ?? document.querySelector(to.hash)
            } catch {
                el = document.getElementById(id)
            }

            if (el) {
                return { el, behavior: 'smooth' }
            }
        }

        return false
    },
}
